import React, {Component} from 'react';
import {connect} from 'react-redux';
import {StringService} from '../../services';
import {ParamKeys, ViaConviteKeys, RouteKeys} from '../../constants';
import {ScreenNotificationDefault, Footer} from '../../components';
import {redirectToEndDataRegistration} from '../../ducks/Navigate';
import {parametroSistemaBuscar} from '../../ducks/SystemParameter';
import {preAvaliacaoObter} from '../../ducks/Customer';
import NumberFormat from 'react-number-format';
import './styles.scss';

class PreEvaluationCompletedSuccess extends Component {
  async componentDidMount() {
    document.title = StringService.formatTitle(
      RouteKeys.PreEvaluationCompletedSuccess.title,
    );

    await this.props.parametroSistemaBuscar(
      ParamKeys.PARAMETRO_SISTEMA_VALIDADE_EM_DIAS,
    );
    await this.props.preAvaliacaoObter(this.props.chave);
  }

  render() {
    const {
      limitePrimeiraCompraAVista,
      limitePrimeiraCompraTurbinado,
      limitePrimeiraCompraAlcada,
      limitePrimeiraCompraSemJuros,
      exibirLimitesPrimeiraCompra,
      limiteCartaoAVista,
      limiteCartaoParcelado,
      exibirLimitesCartao,
      limiteTelesaque,
      exibirLimitesTelesaque,
    } = this.props.limitesPreValidados;
    return (
      <ScreenNotificationDefault
        title={<p>Análise Concluída</p>}
        contentCustom={
          <div className="div-pre-evaluation-completed-success">
            <div className="title">1ª Etapa concluída!</div>
            <br />
            <div className="info justify">
              <i>Agora termine de completar seus dados, é rapidinho!</i>
            </div>
            <br />
            <div className="info justify">
              <i>
                Se você preferir não preencher agora, saiba que este convite é
                válido por até {this.props.valor} dias.
              </i>
            </div>
            <br />
            {(this.props.via === ViaConviteKeys.CodigoAutocaptura ||
              this.props.via === ViaConviteKeys.Promotor) && (
              <div className="info justify">
                <i>
                  Caso queira continuar o preenchimento da proposta em outro
                  momento, enviamos um convite para o seu e-mail, basta acessar
                  o link, preencher o seu CPF e continuar de onde parou.
                </i>
              </div>
            )}

            {(exibirLimitesPrimeiraCompra ||
              exibirLimitesCartao ||
              exibirLimitesTelesaque) && (
              <>
                <div className="title title-pre-limits primary-font">
                  Limites Pré-Validados
                </div>
                {exibirLimitesPrimeiraCompra && (
                  <div className="info justify subtitle-pre-limits primary-font">
                    Limites de 1ª compra
                  </div>
                )}
                {exibirLimitesPrimeiraCompra && limitePrimeiraCompraAVista > 0 && (
                  <div className="info start pre-limits">
                    <strong>À vista:</strong>
                    <NumberFormat
                      value={limitePrimeiraCompraAVista}
                      displayType={'text'}
                      decimalSeparator={','}
                      thousandSeparator={'.'}
                      fixedDecimalScale
                      decimalScale={2}
                    />
                  </div>
                )}
                {exibirLimitesPrimeiraCompra &&
                  limitePrimeiraCompraTurbinado > 0 && (
                    <div className="info start pre-limits">
                      <strong>Turbinado:</strong>
                      <NumberFormat
                        value={limitePrimeiraCompraTurbinado}
                        displayType={'text'}
                        decimalSeparator={','}
                        thousandSeparator={'.'}
                        fixedDecimalScale
                        decimalScale={2}
                      />
                    </div>
                  )}
                {exibirLimitesPrimeiraCompra && limitePrimeiraCompraAlcada > 0 && (
                  <div className="info start pre-limits">
                    <strong>Alçada:</strong>
                    <NumberFormat
                      value={limitePrimeiraCompraAlcada}
                      displayType={'text'}
                      decimalSeparator={','}
                      thousandSeparator={'.'}
                      fixedDecimalScale
                      decimalScale={2}
                    />
                  </div>
                )}
                {exibirLimitesPrimeiraCompra &&
                  limitePrimeiraCompraSemJuros > 0 && (
                    <div className="info start pre-limits">
                      <strong>Sem juros:</strong>
                      <NumberFormat
                        value={limitePrimeiraCompraSemJuros}
                        displayType={'text'}
                        decimalSeparator={','}
                        thousandSeparator={'.'}
                        fixedDecimalScale
                        decimalScale={2}
                      />
                    </div>
                  )}
                {exibirLimitesCartao && (
                  <div className="info justify subtitle-pre-limits primary-font">
                    Limites do Cartão
                  </div>
                )}
                {exibirLimitesCartao && limiteCartaoAVista > 0 && (
                  <div className="info start pre-limits">
                    <strong>À vista:</strong>
                    <NumberFormat
                      value={limiteCartaoAVista}
                      displayType={'text'}
                      decimalSeparator={','}
                      thousandSeparator={'.'}
                      fixedDecimalScale
                      decimalScale={2}
                    />
                  </div>
                )}
                {exibirLimitesCartao && limiteCartaoParcelado > 0 && (
                  <div className="info start pre-limits">
                    <strong>Parcelado:</strong>
                    <NumberFormat
                      value={limiteCartaoParcelado}
                      displayType={'text'}
                      decimalSeparator={','}
                      thousandSeparator={'.'}
                      fixedDecimalScale
                      decimalScale={2}
                    />
                  </div>
                )}
                {exibirLimitesTelesaque && (
                  <div className="info justify subtitle-pre-limits primary-font">
                    Limites Telesaque
                  </div>
                )}
                {exibirLimitesTelesaque && limiteTelesaque > 0 && (
                  <div className="info start pre-limits">
                    <strong>À vista/Parcelado:</strong>
                    <NumberFormat
                      value={limiteTelesaque}
                      displayType={'text'}
                      decimalSeparator={','}
                      thousandSeparator={'.'}
                      fixedDecimalScale
                      decimalScale={2}
                    />
                  </div>
                )}
              </>
            )}
          </div>
        }
        contentButtons={
          <div className="div-data-contact">
            <Footer
              nextForm="frm"
              textNext="Próximo"
              nextHandle={this.props.redirectToEndDataRegistration}
              hideBtnBack={true}
            />
          </div>
        }
      />
    );
  }
}

const mapStateToProps = ({customer, systemParameter}) => {
  const {via, chave, limitesPreValidados} = customer;
  const {valor} = systemParameter;
  return {
    via,
    valor,
    chave,
    limitesPreValidados,
  };
};
export default connect(mapStateToProps, {
  redirectToEndDataRegistration,
  parametroSistemaBuscar,
  preAvaliacaoObter,
})(PreEvaluationCompletedSuccess);
